import styled from 'styled-components';

export const CardHeader = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 100%;
  overflow: hidden;

  h2 {
    font-size: 20px;
    font-weight: bold;
    margin: 0 0 8px 0;
    color: #000;
    flex: 1;
    min-width: 0;
    overflow-wrap: break-word;
    word-break: break-word;

    @media (max-width: 400px) {
      font-size: 16px;
    }
  }
`;

export const Price = styled.div<{ color: string }>`
  color: ${({ color }) => color ?? '#0b6856'};
  font-weight: bold;
  font-size: 16px;

  @media (max-width: 400px) {
    font-size: 14px;
  }
`;
